var CategoryBrowser = React.createClass({
  componentDidMount() {
    RA.KBSearch.search({}, this.categoriesSearchDone);

    $(window).on("resize.ra.categoryBrowser", debounce(this.windowResized, 100).bind(this));
  },
  componentWillUnmount() {
    $(window).off(".categoryBrowser");
  },
  getInitialState() {
    return {
      categories: [],
      categoriesLoaded: false,
      categoryTitles: {},
      isMenuVisible: false,
      activeItem: null
    }
  },
  categoriesSearchDone(r) {
    this.setState({
      categories: r.browsePaths,
      categoriesLoaded: true
    });
  },
  windowResized() {
    let {
      activeItem,
      isMenuVisible
    } = this.state;

    if (!isMenuVisible) return;

    this.setState({
      menuPosition: this.getMenuPosition(activeItem.ref)
    });
  },
  getMenuPosition(ref) {
    let $item = $(ref);
    let $parent = $item.offsetParent();

    let offsetTop = ($item.offset().top - $parent.offset().top) + $item.outerHeight() + 10;

    return {
      offsetTop: offsetTop
    };
  },
  categoryClicked(category, ref) {
    let {
      activeItem,
      categoryTitles
    } = this.state;

    if (activeItem != null && activeItem.category == category) {
      activeItem = null;
      category.isActive = false;
    } else {
      category.isActive = true;
      activeItem = {
        ref: ref,
        category: category
      };

      if (!categoryTitles[category.value]) {
        RA.KBSearch.applyFilter({taxlevelValue: category.value}, (r) => {
          categoryTitles[category.value] = r.browsePaths;
          this.setState({ categoryTitles: categoryTitles });
        });
      }
    }

    this.setState({
      isMenuVisible: activeItem != null,
      activeItem: activeItem,
      menuPosition: this.getMenuPosition(ref)
    });
  },
  closeMenuClicked() {
    let { activeItem } = this.state;

    activeItem.category.isActive = false;

    this.setState({
      isMenuVisible: false,
      activeItem: null
    });
  },
  renderCategoryList() {
    return (
      <CategoryBrowser.List
        categories={this.state.categories}
        onClick={this.categoryClicked} />
    );
  },
  renderNoContent() {
    return <NoContent message={Labels.getLabel("No categories found")} />;
  },
  renderMenu() {
    let {
      isMenuVisible,
      activeItem,
      menuPosition,
      categoryTitles
    } = this.state;

    if (!isMenuVisible) return;

    let style = {
      top: `${menuPosition.offsetTop}px`
    };

    return (
      <CategoryBrowser.Menu
        title={activeItem.category.value}
        browsePaths={categoryTitles[activeItem.category.value]}
        offsetTop = {menuPosition.offsetTop}
        onCloseClicked={this.closeMenuClicked} />
    )
  },
  renderOverlay() {
    if (!this.state.isMenuVisible) return;

    return (
      <Overlay
       showImage={false}
       onClick={this.closeMenuClicked} />
     );
  },
  render() {
    let {
      categories,
      categoriesLoaded
    } = this.state;

    if (!categoriesLoaded) {
      return <Overlay wrap={true} />;
    }

    let content = categories.length == 0 ?
      this.renderNoContent() : this.renderCategoryList();

    return (
      <div className="cat-browser">
        {content}

        {this.renderMenu()}
        {this.renderOverlay()}
      </div>
    );
  }
});


CategoryBrowser.List = React.createClass({
  propTypes: {
    categories: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onClick: React.PropTypes.func.isRequired
  },
  itemClicked(category, e) {
    this.props.onClick(category, e.currentTarget);
  },

  render() {
    let { categories } = this.props;

    let items = categories.map(category => {
      return (
        <CategoryBrowser.Item
          key={category.value}
          name={category.value}
          hits={category.hits}
          isActive={category.isActive}
          onClick={this.itemClicked.bind(this, category)} />
      );
    });

    return (
      <div className="cat-browser__list">
        {items}
      </div>
    )
  }
});


CategoryBrowser.Menu = React.createClass({
  propTypes: {
    offsetTop: React.PropTypes.number,
    title: React.PropTypes.string,
    browsePaths: React.PropTypes.arrayOf(React.PropTypes.object),
    onCloseClicked: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      offsetTop: 0,
      title: "",
      browsePaths: []
    }
  },
  renderItem(item) {
    let browsePath = item.value;
    let paths = browsePath.split("//");
	let url = RA.buildSearchUrl("", { taxonomypath: browsePath }) + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + "#t=kbResults";
    let hits = Number.prototype.toLocaleString ? item.hits.toLocaleString() : item.hits;

    return (
      <li key={browsePath}>
        <a href={url}>
          {paths[paths.length - 1]}
        </a>
        <span className="text-muted"> ({hits})</span>
      </li>
    );
  },
  renderList() {
    let { browsePaths } = this.props;
    let count = browsePaths.length;

    let colOneData = browsePaths;
    let colTwoData = [];

    if (count > 1) {
      let colOneCount = (Math.floor(count / 2)) + (count % 2);
      let colTwoCount = Math.floor(count / 2);

      colOneData = browsePaths.slice(0, colOneCount);
      colTwoData = browsePaths.slice(colOneCount);
    }

    return (
      <div className="row cat-browser__title-list">
        <div className="col-md-6">
          <ul className="bullet-list -indent">
            {colOneData.map(this.renderItem)}
          </ul>
        </div>

        <div className="col-md-6">
          <ul className="bullet-list -indent">
            {colTwoData.map(this.renderItem)}
          </ul>
        </div>
      </div>
    )
  },
  render() {
    let {
      offsetTop,
      browsePaths,
      title
    } = this.props;

    let style = {
      top: `${offsetTop}px`
    };

    let url = RA.buildSearchUrl("", { taxonomypath: title }) + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + "#t=kbResults";

    let content = browsePaths.length ?
      this.renderList() :
      <Overlay wrap={true} imageTimeout={200} />

    return (
      <div className="cat-browser__menu" style={style}>
        <a href="#" className="close" onClick={this.props.onCloseClicked}>&times;</a>
        <h3 className="cat-browser__menu-title">{title}</h3>
        <div className="cat-browser__all-wrap">
          <a href={url}>{Labels.getLabel("See all solutions")}</a>
        </div>
        {content}
      </div>
    );
  }
});


CategoryBrowser.Item = React.createClass({
  propTypes: {
    href: React.PropTypes.string,
    name: React.PropTypes.string,
    hits: React.PropTypes.number,
    isActive: React.PropTypes.bool,
    classNameModifier: React.PropTypes.string,
    onClick: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      href: "#",
      hits: 0,
      isActive: false
    }
  },
  itemClicked(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  },
  render() {
    let {
      name,
      hits,
      href,
      isActive,
      classNameModifier
    } = this.props;

    let label = hits == 1 ? "solution" : "solutions";
    hits = Number.prototype.toLocaleString ? hits.toLocaleString() : hits;

    return (
      <a role="button" href={href}
        className={classNames("cat-browser__item", {"-active": isActive}, classNameModifier)}
        onClick={this.itemClicked}>
        <div className="cat-browser__name">{name}</div>
        <div className="cat-browser__count">{`${hits} ${Labels.getLabel(label)}`}</div>
      </a>
    );
  }
});
